var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":_vm.open,"width":"500","persistent":""}},[_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.$t('app.serviceWorkerNotSupportedHeadline')))]),_c('v-card-text',[_vm._v(" "+_vm._s(_vm.$t('app.serviceWorkerNotSupportedText'))+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }